// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-RadioBox-RadioBox-module__container-HNDfWO","active":"src-app-components-forms-RadioBox-RadioBox-module__active-pxD3fq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-RadioBox-RadioBox-module__container-HNDfWO\",\"active\":\"src-app-components-forms-RadioBox-RadioBox-module__active-pxD3fq\"}";
        // 1789362522824
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  